import React, { Component } from 'react';
import styled from 'styled-components';
import './marker.css'



const Wrapper = styled.div`
position: absolute;
bottom: 10px;
left: -25px;
`;

const Text = styled.div`
  font-size: 14px;
  font-weight: 300;
  p {
    margin: 0;
  }
`

const Textdown = styled.div`
  font-size: 14px;
  font-weight: 300;
  margin-top: 30px;

  p {
    margin: 0;
  }
`

const Tooltip = styled.div`
transition: opacity, transform 0.3s;
`

export default class Marker extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isHovering: false
        };
    }

    handleMouseOver = () => {
        if (this.state.isHovering !== true) {
            this.setState({ isHovering: true })
        }

    }

    handleMouseOut = () => {
        if (this.state.isHovering !== false) {
            this.setState({ isHovering: false })
        }

    }

    render() {
        const {
            title,
            address,
            zip,
            phone,
            mail,
            url
        } = this.props

        return (
            <Wrapper>
                <svg
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 345.91 499.67"
                    width="50"
                    height="50"
                    onMouseOver={this.handleMouseOver}
                    onMouseOut={this.handleMouseOut}
                >
                    <path
                        d="M343.12,141.67C327.05,59.73,257.7,4.06,178.89.18,106.85-3.36,33.55,45.43,9.11,117c-11.95,35-13.17,69.7,2.53,104,5.61,12.27,10.21,25.12,17,36.71q53.33,91.29,107.58,182c11.65,19.6,23.85,38.87,36.84,60C213.55,433.76,253.79,370,292.16,305.15c16.53-28,29.83-57.93,43.41-87.52C346.65,193.47,348.23,167.75,343.12,141.67Z"
                        fill="#004077" />
                    <path
                        d="M173,81.26v0c-58.55,0-107.17,5.82-106.91,75.61,0,71.11,57.7,74.34,106.66,74.35h.42c49,0,106.66-3.24,106.66-74.35.27-69.79-48.27-75.61-106.83-75.61m0,130.48c-38.81-.12-53.72-7.5-53.72-57.9s20.5-53.57,53.72-53.61v0c33.2,0,53.71,3.15,53.71,53.61s-14.91,57.78-53.71,57.9"
                        fill="#fff" stroke="#fff" strokeMiterlimit="10" strokeWidth="2.597018499094645px" />
                    <path
                        d="M196.88,157.19c0-22.44-6.64-25.73-23.93-25.78S149,134.75,149,157.19s9.14,23.86,23.92,23.87,23.93-1.4,23.93-23.87"
                        fill="#fff" stroke="#fff" strokeMiterlimit="10" strokeWidth="2.597018499094645px" />
                </svg>
                <Tooltip
                    className={this.state.isHovering ? 'tooltip' : 'tooltip-hidden'}
                    onMouseOver={this.handleMouseOver}
                    onMouseOut={this.handleMouseOut}
                >
                    <Text>
                        <p>{title}</p>
                        <p>{address}</p>
                        <p>{zip}</p>
                    </Text>
                    <Textdown>
                        <p><a href={`tel:${phone}`}>{phone}</a></p>
                        <p><a href={`mailto:${mail}`}>{mail}</a></p>
                        <p><a href={url} target="_blank">{url}</a></p>
                    </Textdown>
                </Tooltip>
            </Wrapper>
        )
    }
}




// WEBPACK FOOTER //
// ./src/ui/components/modules/Map/Marker.js